// extracted by mini-css-extract-plugin
export var active = "_j3-2";
export var recordingDot = "_j3-1";
export var recordingIndicator = "_j3-0";